var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarOutlineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4517 6.25911L8.99479 3.32713L7.53789 6.25911L4.27751 6.7309L6.63701 9.01301L6.07938 12.2343L8.99479 10.7132L11.9102 12.2343L11.3526 9.01301L13.7121 6.7309L10.4517 6.25911ZM13.4085 13.0743C13.5206 13.7248 12.8303 14.2097 12.2521 13.9079L8.99479 12.2085L5.73748 13.9079C5.15928 14.2121 4.46894 13.7248 4.58109 13.0743L5.20414 9.47509L2.56988 6.92723C2.09636 6.4696 2.35804 5.67061 3.011 5.57661L6.65212 5.04972L8.27953 1.77461C8.57361 1.18341 9.41847 1.19083 9.71006 1.77461L11.3375 5.04972L14.9786 5.57661C15.6315 5.67061 15.8932 6.4696 15.4197 6.92723L12.7854 9.47509L13.4085 13.0743Z",
    fill: "#FFA446"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlineIcon);
export default __webpack_public_path__ + "static/media/starOutlineIcon.c40133f5.svg";
export { ForwardRef as ReactComponent };